import { MouseEventHandler } from 'react';

import { ArrowEnterSolid, Box, Flex, forwardRef } from '@bonusly/design-system';

import { DropdownOption, DropdownOptionProps } from '../Dropdown';

interface SearchResultProps extends Omit<DropdownOptionProps, 'onClick' | 'onMouseOver'> {
	onMouseOver: MouseEventHandler<HTMLDivElement>;
	onClick?: VoidFunction;
	href?: string;
	isSelected: boolean;
}

export const SearchResult = forwardRef<SearchResultProps, 'a'>(({ children, href, isSelected, onClick, onMouseOver, ...rest }, ref) => (
	<Box as="li">
		<DropdownOption
			as="a"
			bg={isSelected ? 'gray.50' : 'white'}
			color="text.default"
			display="block"
			border={0}
			borderRadius="sm"
			p={2}
			tabIndex={undefined}
			href={href}
			onClick={onClick as unknown as MouseEventHandler<HTMLDivElement>}
			onMouseOver={onMouseOver as unknown as MouseEventHandler<HTMLDivElement>}
			ref={ref}
			role="link"
			{...rest}
		>
			<Flex alignItems="center">
				<Box flexGrow={1}>{children}</Box>
				<Box display={{ base: 'none', sm: 'block' }} opacity={Number(isSelected)} pl={2} transitionDuration="normal" transitionProperty="opacity">
					<ArrowEnterSolid color="gray.500" size="sm" />
				</Box>
			</Flex>
		</DropdownOption>
	</Box>
));
